/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Svg } from 'app/components';
import WatchListButton from './styles';

const propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isInWatchList: PropTypes.bool,

  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  watchlist: PropTypes.arrayOf(PropTypes.object).isRequired,
  watchlistErrorId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  addToWatchlist: PropTypes.func.isRequired,
  removeFromWatchlist: PropTypes.func.isRequired,
  isItemInWatchlist: PropTypes.func.isRequired,

  isDetails: PropTypes.bool
};

const defaultProps = {
  isDetails: false,
  isInWatchList: false,
  watchlistErrorId: null
};

const WatchListBtn = ({
  id,
  isInWatchList,
  data,
  watchlist,
  watchlistErrorId,
  addToWatchlist,
  removeFromWatchlist,
  isItemInWatchlist,
  isDetails
}) => {
  const [t] = useTranslation();
  const [isAdded, toggleIcon] = useState(isInWatchList);
  const [isPending, togglePending] = useState(false);
  const listId = id.toString();

  const toggleCb = useCallback(() => {
    const method = isAdded ? removeFromWatchlist : addToWatchlist;

    togglePending(true);
    method(listId);
  }, [isAdded, listId]);

  useEffect(() => {
    if (!isPending) {
      return;
    }

    toggleIcon(false);
    togglePending(false);

    if (isItemInWatchlist(watchlist, listId)) toggleIcon(true);
  }, [data, watchlist]);

  useEffect(() => {
    if (listId === watchlistErrorId) {
      togglePending(false);
    }
  }, [watchlistErrorId]);

  const className = () => {
    if (isPending) {
      return isAdded ? ' _filled _pending' : ' _pending';
    }

    if (!isAdded) {
      return '';
    }

    return ' _filled';
  };

  return (
    <WatchListButton
      type="button"
      onClick={toggleCb}
      className={`btn-watchlist${className()}`}
      isDetails={isDetails}
    >
      <Svg id="heart" />
      {isDetails ? (
        <span>{isAdded ? t('watchList.remove') : t('watchList.add')}</span>
      ) : (
        <Svg id="bookmark" />
      )}
    </WatchListButton>
  );
};

WatchListBtn.propTypes = propTypes;
WatchListBtn.defaultProps = defaultProps;
export default WatchListBtn;
